import { render } from "./manual-transfer-confirm-popup.vue?vue&type=template&id=5a1625d1&scoped=true&ts=true"
import script from "./manual-transfer-confirm-popup.vue?vue&type=script&lang=ts"
export * from "./manual-transfer-confirm-popup.vue?vue&type=script&lang=ts"

import "./manual-transfer-confirm-popup.vue?vue&type=style&index=0&id=5a1625d1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1625d1"]])

export default __exports__